import React from 'react';
import {ArrowDown} from '../../../icons';

/**
 * El umbral entre dos actos: la frase que explica por qué el siguiente existe.
 *
 * **La frase va partida en dos** (`text` + `em`) y el remate va en negrita, con una flecha ↓ delante
 * (mockup: `.th-pill` abre con un SVG de flecha y cierra con `<b>baja aquí a revisión</b>`). No es
 * decoración: el umbral tiene que leerse como una DIRECCIÓN —lo que pasa arriba cae abajo—, y en una
 * sola tinta era una oración más entre dos secciones. La partición en dos claves es el mismo patrón
 * que el toggle del instructivo (`guide_toggle` + `guide_toggle_em`); con una sola clave habría que
 * meter markup adentro del i18n.
 *
 * "Lo que Dashbo encuentra en el material baja aquí a revisión — 7 esperan tu ok" sólo se puede
 * decir entre dos secciones contiguas. Es la pieza que se perdía con el Recorrido repartido en
 * cuatro rutas: cada pantalla podía contar lo que hacía, pero ninguna podía mostrar el vínculo
 * causal con la siguiente, que es de lo que trata el Recorrido.
 *
 * El hilo se dibuja en DOS segmentos —el que entra y el que sale— con una chispa que baja por cada
 * uno, desfasada, para que se lea como una sola luz atravesando la cápsula.
 *
 * Es un `<a href="#...">` real y no un div con onClick: se puede tabular, Enter lo activa y
 * funciona aunque el scroll suave no llegue a correr.
 *
 * ⚠️ **El href es SÓLO el fragmento, nunca la ruta completa.** El navegador hace navegación por
 * fragmento —sin recargar el documento— únicamente cuando la URL destino coincide con la actual
 * salvo el `#`. Con el path escrito entero (`/client/42/booster#revisa`) alcanzaba con que la URL
 * llevara cualquier query para que dejaran de coincidir: entrar por el deep-link de la Bitácora
 * (`?layers=…`), por el atajo `?connect=drive` o desde un mail con `?utm=` convertía el click en un
 * **boot completo de la SPA**. Con `#revisa` a secas el navegador lo resuelve contra la URL actual,
 * así que path y query se preservan solos y no hay nada que sincronizar.
 */
export function BoosterThreshold({to, text, em, count, tone}) {
    return (
        <div className="iab-flow-thresh iab-rv">
            <span className="iab-flow-thline" aria-hidden="true"/>
            <a className="iab-flow-thpill" href={`#${to}`}>
                <ArrowDown className="iab-flow-tharrow" size={13} weight="bold" aria-hidden="true"/>
                <span className="iab-flow-thtext">
                    {text}
                    {em && <> <b>{em}</b></>}
                </span>
                {count && (
                    <span className={`iab-flow-thn ${tone === 'warn' ? '-warn' : ''}`}>{count}</span>
                )}
            </a>
            <span className="iab-flow-thline -out" aria-hidden="true"/>
        </div>
    );
}

export default BoosterThreshold;
